// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.


import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
import "bootstrap"
import "../stylesheets/application"

require("custom/select2.min")

require('jquery')
require('cocoon-js')

// import 'select2-full'
// import 'select2'
// import 'select2/dist/css/select2.css'

import ApexCharts from 'apexcharts'
window.ApexCharts = ApexCharts



Rails.start()
Turbolinks.start()
ActiveStorage.start()

function hideRenaveFacilLoading() {
  const overlay = document.getElementById("renave-facil-loading")
  const link = document.querySelector("[data-renave-facil-loading]")

  if (overlay) {
    overlay.hidden = true
    overlay.setAttribute("aria-hidden", "true")
  }
  if (document.body) document.body.removeAttribute("aria-busy")
  if (link) {
    link.classList.remove("disabled")
    link.removeAttribute("aria-disabled")
    delete link.dataset.loading
  }
}

document.addEventListener("click", function(event) {
  const link = event.target.closest("[data-renave-facil-loading]")
  if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return

  if (link.dataset.loading === "true") {
    event.preventDefault()
    return
  }

  const overlay = document.getElementById("renave-facil-loading")
  if (!overlay) return

  link.dataset.loading = "true"
  link.classList.add("disabled")
  link.setAttribute("aria-disabled", "true")
  overlay.hidden = false
  overlay.setAttribute("aria-hidden", "false")
  document.body.setAttribute("aria-busy", "true")
})

document.addEventListener("turbolinks:before-cache", hideRenaveFacilLoading)
window.addEventListener("pageshow", hideRenaveFacilLoading)

// $(document).on('turbolinks:load', function(){
//   console.log('Estamos prontos! Turbo link')
// })

 



